/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Rate_WeeklyInputs */

const en_rental_rate_weekly = /** @type {(inputs: Rental_Rate_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly Rate (per night)`)
};

const es_rental_rate_weekly = /** @type {(inputs: Rental_Rate_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifa Semanal (por noche)`)
};

const fr_rental_rate_weekly = /** @type {(inputs: Rental_Rate_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif hebdomadaire (par nuit)`)
};

const de_rental_rate_weekly = /** @type {(inputs: Rental_Rate_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wochenrate (pro Nacht)`)
};

const id_rental_rate_weekly = /** @type {(inputs: Rental_Rate_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif Mingguan (per malam)`)
};

/** @type {(inputs: Rental_Rate_WeeklyInputs) => LocalizedString} */
const ja_rental_rate_weekly = en_rental_rate_weekly;

/** @type {(inputs: Rental_Rate_WeeklyInputs) => LocalizedString} */
const zh_rental_rate_weekly = en_rental_rate_weekly;

/** @type {(inputs: Rental_Rate_WeeklyInputs) => LocalizedString} */
const ar_rental_rate_weekly = en_rental_rate_weekly;

/** @type {(inputs: Rental_Rate_WeeklyInputs) => LocalizedString} */
const it_rental_rate_weekly = en_rental_rate_weekly;

/** @type {(inputs: Rental_Rate_WeeklyInputs) => LocalizedString} */
const ru_rental_rate_weekly = en_rental_rate_weekly;

/** @type {(inputs: Rental_Rate_WeeklyInputs) => LocalizedString} */
const pt_rental_rate_weekly = en_rental_rate_weekly;

/** @type {(inputs: Rental_Rate_WeeklyInputs) => LocalizedString} */
const ko_rental_rate_weekly = en_rental_rate_weekly;

/**
* | output |
* | --- |
* | "Weekly Rate (per night)" |
*
* @param {Rental_Rate_WeeklyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_rate_weekly = /** @type {((inputs?: Rental_Rate_WeeklyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Rate_WeeklyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_rate_weekly(inputs)
	if (locale === "es") return es_rental_rate_weekly(inputs)
	if (locale === "fr") return fr_rental_rate_weekly(inputs)
	if (locale === "de") return de_rental_rate_weekly(inputs)
	if (locale === "ja") return ja_rental_rate_weekly(inputs)
	if (locale === "zh") return zh_rental_rate_weekly(inputs)
	if (locale === "ar") return ar_rental_rate_weekly(inputs)
	if (locale === "id") return id_rental_rate_weekly(inputs)
	if (locale === "it") return it_rental_rate_weekly(inputs)
	if (locale === "ru") return ru_rental_rate_weekly(inputs)
	if (locale === "pt") return pt_rental_rate_weekly(inputs)
	return ko_rental_rate_weekly(inputs)
});